import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../../../Store';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';
import {
	getChannelsFromUser,
	getAllMedias,
	setUserChannels,
	setGroupChannels,
} from '../../../../../Store/AppsManagement/Actions';
import {
	IAppsManagementState,
	Media,
} from '../../../../../Store/AppsManagement/Types';
import { I18N } from '../../../../../Store/I18n/Types';
import { IUserState } from '../../../../../Store/User/Types';
import { getTheme } from '../../../../../Themes';
import { getACLUserByID } from '../../../../../Store/UserManagement/Actions';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyArray,
	isNullOrUndefinedOrEmptyString,
} from '../../../../../Utils/Various';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	appsManagement: IAppsManagementState;
}

interface IState {
	mode: number;
	updatedChannels: Media[];
}

interface IPropsFromDispatch {
	getAllMedias: typeof getAllMedias;
	getACLUserByID: typeof getACLUserByID;
	getChannelsFromUser: typeof getChannelsFromUser;
	setGroupChannels: typeof setGroupChannels;
	setUserChannels: typeof setUserChannels;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	table: {
		minWidth: 750,
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	smallIcon: {
		padding: '3px',
	},
	cell5: {
		width: '5%',
	},
	cell125: {
		width: '12.5%',
	},
	cell15: {
		width: '15%',
	},
	cell20: {
		width: '20%',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class GroupOrUserChannelsComponent extends React.Component<
	AllProps,
	IState
> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			mode: 0,
			updatedChannels: [],
		};
	}

	public componentDidMount() {
		if (this.props.router.match.params.groupName !== undefined) {
			if (this.props.router.match.params.groupName !== 'undefined') {
				this.props.getACLUserByID(
					this.props.user.token,
					parseInt(this.props.router.match.params.groupName, 10)
				);
				if (this.props.router.match.params.type !== undefined) {
					if (this.props.router.match.params.type !== 'undefined') {
						const group =
							this.props.router.match.params.type ===
							'mediaarchiver-group';
						this.props.getChannelsFromUser(
							parseInt(
								this.props.router.match.params.groupName,
								10
							),
							group
						);
					}
				}
			}
		}
		if (
			isNullOrUndefinedOrEmptyArray(this.props.appsManagement.allMedias)
		) {
			this.props.getAllMedias();
		}
	}

	public componentDidUpdate(prevProps: AllProps, prevState: IState) {
		if (
			prevProps.appsManagement.userChannels !==
			this.props.appsManagement.userChannels
		) {
			this.setState({
				updatedChannels: this.props.appsManagement.userChannels,
			});
		}
	}

	public render(): React.ReactNode {
		const group =
			this.props.router.match.params.type === 'mediaarchiver-group';
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={this.state.mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab
						label={group ? 'Group channels' : 'User channels'}
					/>
					<MD.Tab label={this.props.i18n._('Update channels')} />
				</MD.Tabs>
				<this.TabPanel value={this.state.mode} index={0}>
					{this.renderUserOrGroupChannels()}
				</this.TabPanel>
				<this.TabPanel value={this.state.mode} index={1}>
					{this.renderUpdateChannelsToUserOrGroup()}
				</this.TabPanel>
			</React.Fragment>
		);
	}

	private TabPanel(props: any): JSX.Element {
		const { children, value, index } = props;
		return <div>{value === index && <div>{children}</div>}</div>;
	}

	private handleTabs(e: React.ChangeEvent<{}>, val: number) {
		switch (val.toString(10)) {
			case '0':
				this.setState({ mode: 0 });
				break;
			case '1':
				this.setState({ mode: 1 });
				break;
			default:
				this.setState({ mode: 0 });
		}
	}

	public renderUpdateChannelsToUserOrGroup(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<MD.TableContainer component={MD.Paper}>
					<MD.Table size="small">
						<MD.TableHead>
							<MD.TableRow id="tablerowuser">
								<MD.TableCell className={classes.cell125} />
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('ID')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('SOURCE')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('First Chunk')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Last Chunk')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Encoding')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Type')}
								</MD.TableCell>
								<MD.TableCell className={classes.cell125}>
									{this.props.i18n._('Remove Channel')}
								</MD.TableCell>
							</MD.TableRow>
						</MD.TableHead>
						{this.displayTableBodyUpdate()}
					</MD.Table>
				</MD.TableContainer>
				{this.generateAddRowChannel()}
			</React.Fragment>
		);
	}

	public renderUserOrGroupChannels(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				{this.props.appsManagement.loadingUserChannels ? (
					<div style={{ paddingTop: 30 }}>
						{this.props.i18n._('Loading')}...
					</div>
				) : (
					<>
						<MD.TableContainer component={MD.Paper}>
							<MD.Table
								aria-label="collapsible table"
								size="small"
							>
								<MD.TableHead>
									<MD.TableRow id="tablerowuser">
										<MD.TableCell
											className={classes.cell125}
										/>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('ID')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('SOURCE')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('First Chunk')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Last Chunk')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Encoding')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Type')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
										>
											{this.props.i18n._(
												'Fetch users/groups'
											)}
										</MD.TableCell>
									</MD.TableRow>
								</MD.TableHead>
								{this.displayTableBody()}
							</MD.Table>
						</MD.TableContainer>
					</>
				)}
			</React.Fragment>
		);
	}

	private displayTableBody(): React.ReactNode | string {
		const classes = this.props.classes;

		if (this.props.appsManagement.userChannels.length !== 0) {
			return (
				<MD.TableBody>
					{this.props.appsManagement.userChannels.map((m, i) =>
						this.generateRow(m, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={7} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}

	private generateAddRowChannel() {
		return (
			<React.Fragment>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						const updatedChannels = this.state.updatedChannels;
						const newChannel = this.getEmptyChannel();
						updatedChannels.push(newChannel);
						this.setState({ updatedChannels });
					}}
				>
					{this.props.i18n._('Add channel')}
				</MD.Button>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						this.updatetoSTTChannels();
					}}
				>
					{this.props.i18n._('Add STT channels')}
				</MD.Button>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						this.updatetoMTChannels();
					}}
				>
					{this.props.i18n._('Add Panel MA channels')}
				</MD.Button>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						let channelsID: number[] = [];
						for (const key in this.state.updatedChannels) {
							if (
								Object.prototype.hasOwnProperty.call(
									this.state.updatedChannels,
									key
								)
							) {
								const element = this.state.updatedChannels[key];
								if (element.id !== 0) {
									channelsID.push(element.id);
								}
							}
						}
						this.props.router.match.params.type ===
						'mediaarchiver-group'
							? this.props.setGroupChannels(
									channelsID,
									parseInt(
										this.props.router.match.params
											.groupName,
										10
									)
							  )
							: this.props.setUserChannels(
									channelsID,
									parseInt(
										this.props.router.match.params
											.groupName,
										10
									)
							  );
					}}
				>
					{this.props.i18n._('Update')}
				</MD.Button>
			</React.Fragment>
		);
	}

	private updatetoSTTChannels() {
		const allowedid = [
			163859, 170738, 169078, 168239, 76770, 76771, 76772, 76769, 76762,
			76761, 557, 166859, 165038, 555, 548, 37981,
		];

		let parents = [...this.props.appsManagement.allMedias];
		parents = parents.filter((media) => allowedid.includes(media.id));

		let updatedChannels = this.state.updatedChannels;

		parents.push(...updatedChannels);

		this.setState({ updatedChannels: parents });
	}
	private updatetoMTChannels() {
		const allowedid = [
			552, 557, 544, 178787, 166859, 165038, 555, 166866, 553, 551, 76842,
			547, 3, 554, 561, 562, 558, 548, 559, 541, 37981, 1, 38003, 163661,
			38004, 167349, 162723, 163660, 166873, 550, 163662, 162741, 165678,
			162721, 168201, 556, 162781, 38002, 560, 162722, 179332, 163859,
			168239, 76773, 179327, 170478, 76770, 76771, 185823, 76772, 170739,
			76762, 168240, 179331, 179329, 76761, 179328, 168238, 76778, 168258,
			179213, 179214, 179215, 179216, 179217, 179218, 179219, 179220,
			179221, 179223, 179224, 179225, 179226, 179227, 179228, 179229,
			179230, 185030, 179231, 179232, 179233, 179234, 179235, 179236,
			185009, 185669, 185668, 181788, 170738, 169078, 175785, 181548,
			76769, 167198, 178553, 165638, 76781, 183088, 76766, 76780, 76783,
			180473, 76765, 76764, 172470, 76777, 178878, 168699, 182170, 182171,
		];

		let parents = [...this.props.appsManagement.allMedias];
		parents = parents.filter((media) => allowedid.includes(media.id));

		let updatedChannels = this.state.updatedChannels;

		parents.push(...updatedChannels);

		this.setState({ updatedChannels: parents });
	}

	private displayTableBodyUpdate(): React.ReactNode | string {
		const classes = this.props.classes;

		if (this.state.updatedChannels.length !== 0) {
			return (
				<MD.TableBody>
					{this.state.updatedChannels.map((m, i) =>
						this.generateRowUpdated(m, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={7} className={classes.noResult}>
							Waiting new channels
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}

	private generateRow(media: Media, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell></MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{media.id}
					</MD.TableCell>
					<MD.TableCell align="left">{media.name}</MD.TableCell>
					<MD.TableCell align="left">
						{media.firstChunk === 0
							? 'No Data'
							: new Date(media.firstChunk).toUTCString()}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.lastChunk === 0
							? 'No Data'
							: new Date(media.lastChunk).toUTCString()}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.encoding
							? this.props.i18n._('Currently Encoding')
							: this.props.i18n._('Not Encoding')}
					</MD.TableCell>
					<MD.TableCell align="left">{media.type}</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/apps/mediaarchiver/${media.id}`
								);
							}}
						>
							Fetch Users-Groups
						</MD.Button>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private generateRowUpdated(media: Media, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell>
						<Autocomplete
							id="combo-box-parent"
							options={this.getPossibleMedias()}
							onChange={(ev: React.ChangeEvent<{}>, val: any) => {
								if (
									!isNullOrUndefined(val) &&
									!isNullOrUndefinedOrEmptyString(val.name)
								) {
									this.updateChannelsInformation(i, val);
								}
							}}
							getOptionLabel={(option) => option.name}
							renderInput={(
								params: AutocompleteRenderInputParams
							) => (
								<MD.TextField
									{...params}
									label={this.props.i18n._('Channel')}
									value={media.name}
									onChange={(event: any) => {}}
								/>
							)}
						/>
					</MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{media.id}
					</MD.TableCell>
					<MD.TableCell align="left">{media.name}</MD.TableCell>
					<MD.TableCell align="left">
						{media.firstChunk === 0
							? 'No Data'
							: new Date(media.firstChunk).toUTCString()}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.lastChunk === 0
							? 'No Data'
							: new Date(media.lastChunk).toUTCString()}
					</MD.TableCell>
					<MD.TableCell align="left">
						{media.encoding
							? this.props.i18n._('Currently Encoding')
							: this.props.i18n._('Not Encoding')}
					</MD.TableCell>
					<MD.TableCell align="left">{media.type}</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.removeChannelsInformation(media);
							}}
						>
							{this.props.i18n._('Remove')}
						</MD.Button>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private getPossibleMedias(): Media[] {
		const parents = [...this.props.appsManagement.allMedias];
		return parents;
	}

	private updateChannelsInformation(index: number, media: Media) {
		const updatedChannels = this.state.updatedChannels;
		updatedChannels[index] = media;
		this.setState({ updatedChannels });
	}

	private removeChannelsInformation(mediatoremove: Media) {
		const updatedChannels: Media[] = [];
		const array = this.state.updatedChannels;
		for (const key in array) {
			if (Object.prototype.hasOwnProperty.call(array, key)) {
				const element = array[key];
				if (element !== mediatoremove) {
					updatedChannels.push(element);
				}
			}
		}
		this.setState({ updatedChannels });
	}

	private getEmptyChannel(): Media {
		return {
			encoding: false,
			firstChunk: 0,
			id: 0,
			lastChunk: 0,
			mediaSource: 0,
			type: 0,
			name: '',
			start: '',
			end: '',
		};
	}
}

const mapStateToProps = (
	{ appsManagement, i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	appsManagement,
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLUserByID: (token: string, params: number) =>
		dispatch(getACLUserByID(token, params)),
	getChannelsFromUser: (userID: number, group: boolean) =>
		dispatch(getChannelsFromUser(userID, group)),
	getAllMedias: () => dispatch(getAllMedias()),
	setGroupChannels: (channelsID: number[], id: number) =>
		dispatch(setGroupChannels(channelsID, id)),
	setUserChannels: (channelsID: number[], id: number) =>
		dispatch(setUserChannels(channelsID, id)),
});

export const GroupOrUserChannels = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(GroupOrUserChannelsComponent));
